export default __webpack_public_path__ + "static/media/FrenchFries.91b6d8c9.jpg";